import {} from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import * as React from 'react';
import './SectionHeader.scss';

export interface ISectionHeaderProps {
  className?: string | object;
}

const SectionHeader: React.FC<ISectionHeaderProps> = (props) => {
  const { className, children } = props;

  const classes = classNames('section-header', className);

  return <header className={classes}>{children}</header>;
};

export default SectionHeader;
